<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-lishishuju"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.HistoricalRecord') }}</div>
                <div class="desc">{{ $t('ems.history.desc') }}</div>
            </div>
            <div class="navRight">
                <template v-if="false">
                    <div class="creatTime" v-if="updateTime">{{ $t('ems.history.DataUpdateTime') }}<span>{{updateTime}}</span></div>
                    <div class="btn" @click="fresh"><i class="iconfont icon-shuaxin"></i>{{ $t('ems.history.refresh') }}</div>
                    <div class="btn" style="width: 110px"  @click="fresh"><i class="iconfont icon-banbengengxin"></i>{{ $t('ems.history.UpdateTheData') }}</div>
                </template>
            </div>
        </div>
        <div class="content" v-loading="loading"  element-loading-text="Loading"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(42, 43, 44, 0.6)">
            <div class="table_box">
                <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-width="80px" label-position="left" :model="form">
                    <el-form-item><el-input v-model="form.logContent" :placeholder="$t('ems.history.PleaseEnterContent1')" style="width: 320px"></el-input></el-form-item>
                    <el-form-item style="width: 130px"><el-select popper-class="selectDown" v-model="form.logStatus" :placeholder="$t('ems.history.state')" clearable>
                        <el-option :label="$t('ems.history.successful')" value="0"></el-option>
                        <el-option :label="$t('ems.history.failure')" value="1"></el-option>
                    </el-select></el-form-item>
                    <el-form-item style="width: 130px"><el-select popper-class="selectDown" v-model="form.logType" :placeholder="$t('ems.history.type')" clearable>
                        <el-option :label="$t('ems.history.EquipmentControl')" value="1"></el-option> 
                        <el-option :label="$t('ems.history.SchedulingOperation')" value="2"></el-option>
                    </el-select></el-form-item>
                    <el-form-item style="width: 400px">
                        <el-date-picker
                                v-model="form.time"
                                type="daterange"
                                :range-separator="$t('ems.history.to')"
                                :start-placeholder="$t('ems.history.StartDate')" 
                                :end-placeholder="$t('ems.history.EndDate')"
                                style="width: 100%"
                                popper-class="dateDown"
                        >
                        </el-date-picker>
                    </el-form-item>

                    <div class="btn btn_active" @click="search"><i class="iconfont icon-sousuo"></i><span>{{ $t('ems.history.search') }}</span></div>
                    <div class="btn btn_active" @click="reset"><i class="iconfont icon-reset"></i><span>{{ $t('ems.history.reset') }}</span></div>
                    <div class="btn btn_active" @click="downLoad"><i class="el-icon-download"></i><span>{{ $t('index.export') }}</span></div>
                    <div class="btn btn_active" @click="search" style="float:  right"><i class="iconfont icon-shuaxin"></i><span>{{ $t('ems.history.refresh') }}</span></div>
                </el-form>
                <el-table
                        :data="list"
                        style="width: 100%"
                        v-loading="listLoading"
                        border
                        size="small"
                        :height="700"
                        class="BMSTable"
                >
                    <el-table-column type="index" width="50" align="center">
                        <template slot-scope="scope">
                            <span>{{(page - 1) * size + scope.$index + 1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  :label="$t('ems.history.state')" align="center" width="120">
                        <template slot-scope="scope">
                            <span style="height: 34px; line-height: 34px">{{scope.row.logStatus | status}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  :label="$t('ems.history.content')" prop="logContent"  align="left" :show-overflow-tooltip="true" width="670">
                    </el-table-column>
                    <el-table-column  :label="$t('ems.history.type')"  align="center" width="240">
                        <template slot-scope="scope">
                            <span style="height: 34px; line-height: 34px">{{scope.row.logType | type}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  :label="$t('ems.history.TimeofOccurrence')" prop="happenTime" align="center" width="200"></el-table-column>
                    <el-table-column  :label="$t('ems.history.Dealingwithpeople')"  align="center" width="200">
                        <template slot-scope="scope">
                            <span style="height: 34px; line-height: 34px">{{scope.row.logInvoker}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                            class="pagePagination"
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            layout="total, sizes, prev, pager, next,jumper"
                            :page-size="size"
                            :page-sizes="[ 15, 30, 100 ]"
                            :current-page.sync="page"
                            :total="total"
                            popper-class="selectDown"
                    ></el-pagination>
                    <!--                popper-class-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getHisList, getHisUpdatetime, exportLog} from "@/api/spms";
    import { setStore, getStore } from "@/utils/store";
    import { mapGetters } from "vuex";
    import moment from "moment";
    import i18n from "@/lang";
    import { exportFile } from "@/utils/util";

    export default {
        name: "operationSys",
        data(){
            return {
                groupNo: getStore({name: "siteNo"})||"",
                updateTime: "",
                loading: false,
                form: {
                    logContent: "",
                    logStatus: "",
                    logType: "",
                    time: ""
                },
                isLoading: false,
                size: 15,
                page: 1,
                list: [],
                total: 0,
                listLoading: true,
            }
        },
        filters:{
            status(val) {
                if (val == 0) {
                    return i18n.t("ems.history.successful")
                } else if (val == 1) {
                    return i18n.t("ems.history.failure")
                } else {
                    return i18n.t("ems.history.TheUnknown") 
                }
            },
            type(val){
                if (val == 1) {
                    return i18n.t("ems.history.EquipmentControl") 
                } else if (val == 2) {
                    return i18n.t("ems.history.SchedulingOperation") 
                } else {
                    return i18n.t("ems.history.TheUnknown") 
                }
            }

        },
        computed: {
            ...mapGetters(["language"]),
        },
        created(){
            this.loadData();

        },
        methods: {
            search(){
                this.loadData();
            },
            loadData(){
                this.listLoading = true;
                const params = {... this.form};
                params.isThirdParty = 0;
                params.size = this.size;
                params.current = this.page;
                if(params.time){
                    params.startHappenTime = params.time[0].getTime();
                    params.endHappenTime = params.time[1].getTime();
                }
                getHisList(params).then(res => {
                    this.listLoading = false;
                    this.total = res.data.data.total;
                    this.list = res.data.data.records;
                    this.loadUpdate(this.groupNo)
                }).catch(err => {
                    console.log(err);
                });
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },
            reset(){
                this.form= {
                    logContent: "",
                        logStatus: "",
                        logType: "",
                        time: ""
                };
                this.page= 1;
                this.loadData();
            },
            loadUpdate(){
                getHisUpdatetime(this.groupNo).then(res => {
                    this.updateTime = res.data.data;
                })
            },
            downLoad(){
                const params = {... this.form};
                if(params.time !== "" && params.time.length > 0){
                    params.startHappenTime = params.time[0].getTime();
                    params.endHappenTime = params.time[1].getTime();
                    delete params.time
                }else{
                    this.$message.warning(i18n.t("ems.strategy.PleaseSelectTip") + i18n.t("bms.dynamic.time_range") )
                    return false;
                }
                this.loading = true;
                exportLog(params).then(res => {
                    this.loading = false;
                    this.$message.success("downloading");
                    exportFile(res.data, "log" + moment().format("YYYYMMDDHHmm"));
                }).catch(err => {
                    this.loading = false;
                    console.log(err)
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../styles/site";
    .win{
        transition: all 0.5s linear;
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
            .navRight{
                position: absolute;
                height: 100%;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                .creatTime{
                    font-size: 18px;
                    color: $_191_191_191;
                    margin-right: 40px;
                    span{
                        padding-left: 20px;
                        color: $font_bright_blue_title
                    }
                }
                .btn{
                    height: 30px;
                    width: 85px;
                    border: $font_bright_blue_title solid 2px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: $font_bright_blue_title;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        margin-right: 5px;
                        font-size: 18px;
                    }
                }
            }
        }
        .content{
            height: calc(100% -  52px);
            padding: 0 30px;
            overflow: hidden;
        }
        .table_box{
            .table_header{
                margin-top: 20px;
                height: 30px;
                margin-bottom: 20px;
            }
            .page{
                margin-top: 10px;
            }
        }
        .btn {
            display: inline-block;
            height: 28px;
            width: 80px;
            color: $_191_191_191;
            border: $_191_191_191 solid 2px;
            font-size: 15px;
            cursor: pointer;
            -webkit-tap-highlight-color:rgba(0,0,0,0);
            transition: all 300ms linear;
            line-height: 26px;
            text-align: center;
            i {
                margin-right: 5px;
                font-size: 18px;
            }
            span{
                margin-top: -2px;
            }
        }
        .btn_active{
            border: $font_bright_blue_title solid 2px;
            color: $font_bright_blue_title;
        }
    }
</style>